import BaseTracker from './BaseTracker';
import kochavaApiWrapper from './kochavaApiWrapper';

// Events to forward to Kochava
export const kochavaEventWhitelist = [
  'PS Completed', // Pro signup
  'P Subscription Success', // Add card
  'P Payments Completed Onboarding', // Payments opt-in
  'P Trial Restart', // "Oldie" trial restart
  'P Submitted Cancel Subscription', // Cancel subscription
  'PA Booked First', // Pro booked first appt
  'client_appointment_booked', // Client booked appt
  'landing',
];

class KochavaTracker extends BaseTracker {
  constructor(env: string, platform: string, isApp: boolean) {
    super('kochava', 'Kochava', env, platform);
    kochavaApiWrapper.init(isApp, env === 'production');
  }

  trackEvent(eventName, properties) {
    try {
      if (kochavaEventWhitelist.indexOf(eventName) >= 0) {
        this.debugLog('trackEvent', eventName, properties);
        kochavaApiWrapper.trackEvent(this.isApp, eventName, properties);
      }
    } catch (e) {
      console.error(e);
    }
    return Promise.resolve();
  }
}

export default KochavaTracker;
